import React, { useState } from "react";
import PropTypes from "prop-types";
import AppListItem from "../AppListItem";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

export function AppList({ apps }) {
  const [items, setItems] = useState(apps);

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const newItems = reOrder(
      items,
      result.source.index,
      result.destination.index
    );

    setItems(newItems);
  };

  const reOrder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {items.map((app, index) => (
              <AppListItem key={app.id} app={app} index={index} />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

AppList.propTypes = {
  apps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
};
